const POShipmentSearchType = {
  GET_SHIPMENT_INFO_LIST: 'GET_SHIPMENT_INFO_LIST',
  GET_SHIPMENT_INFO_LIST_FAIL: 'GET_SHIPMENT_INFO_LIST_FAIL',
  GET_SHIPMENT_INFO_LIST_RESET: 'GET_SHIPMENT_INFO_LIST_RESET',
  GET_SHIPMENT_INFO_LIST_SUCCESS: 'GET_SHIPMENT_INFO_LIST_SUCCESS',
  SAVE_SHIPMENT_OTHER_DETAILS_FAIL: 'SAVE_SHIPMENT_OTHER_DETAILS_FAIL',
  SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS: 'SAVE_SHIPMENT_OTHER_DETAILS_PROGRESS',

  SET_SHIPMENT_SEARCH_EXPORT_TOGGLE: 'SET_SHIPMENT_SEARCH_EXPORT_TOGGLE',

  UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS: 'UPDATE_SHIPMENT_INFO_LIST_CHECKED_ITEMS',
  UPDATE_SHIPMENT_INFO_LIST_REQUEST: 'UPDATE_SHIPMENT_INFO_LIST_REQUEST',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default POShipmentSearchType;
